import { createFileRoute } from '@tanstack/react-router';
import type { JSX } from 'react';

import { WhatsNewArchive } from '@/features/whats-new/WhatsNewArchive.js';

export const Route = createFileRoute('/whats-new')({
  component: WhatsNewPage,
});

function WhatsNewPage(): JSX.Element {
  return <WhatsNewArchive />;
}
